"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
var collection_list_style_1 = require("../collection.list/collection.list.style");
exports.CSS = {
    container: 'c-PMCollectionList',
    toolbar: {
        container: 'c-PMCollectionList__Toolbar'
    },
    collections: {
        container: 'c-PMCollectionList__Collections',
        content: 'c-PMCollectionList__Content',
        isEmpty: 'c-PMCollectionList__Collections--empty'
    },
    map: {
        container: 'c-PMCollectionList__Map',
        button: 'c-PMCollectionList__MapBtn'
    }
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        display: 'flex',
        'flex-direction': 'column',
        height: '100%',
        'background-color': theme_1.DefaultTheme.background.grey
    },
    _a[exports.CSS.toolbar.container] = {
        position: 'relative'
    },
    _a[exports.CSS.collections.container] = {
        flex: 1,
        'min-height': '100px',
        display: 'flex',
        'flex-direction': 'column'
    },
    _a[exports.CSS.collections.content] = (_b = {
            display: 'flex',
            flex: 1,
            'flex-direction': 'row',
            overflow: 'hidden'
        },
        _b["& .".concat(collection_list_style_1.CSS.container)] = {
            flex: 1,
            overflow: 'auto'
        },
        _b),
    _a[exports.CSS.collections.isEmpty] = {
        'flex-direction': 'row',
        'justify-content': 'center',
        'align-items': 'center'
    },
    _a[exports.CSS.map.container] = {
        flex: 0.77,
        border: "1px solid ".concat(theme_1.DefaultTheme.font.color.divider)
    },
    _a[exports.CSS.map.button] = {
        position: 'absolute',
        bottom: theme_1.DefaultTheme.space(8),
        left: theme_1.DefaultTheme.space(3),
        color: theme_1.DefaultTheme.font.color.primary,
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp6
    },
    _a);
//# sourceMappingURL=photomeasure.collection.list.style.js.map